import React, { useState } from 'react';
import { Box, Card, Checkbox, Chip, Tooltip, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WebhookIcon from '@mui/icons-material/Webhook';
import HubIcon from '@mui/icons-material/Hub';

const Grid = ({
  header = 'Community Name',
  error,
  address,
  communityPhone,
  preLiveLeadsIngested = 0,
  knockWebhookEnabled,
  applySettingsData,
  apptId,
  removeOnboard,
  tag,
  isCLOProperty
}) => {
  const [checked, setChecked] = useState(false);
  const handleChange = e => {
    e.stopPropagation();
    setChecked(prev => {
      if (!prev) {
        applySettingsData(apptId);
      } else {
        removeOnboard(apptId);
      }
      return !prev;
    });
  };

  return (
    <Card
      variant="outlined"
      sx={{
        position: 'relative',
        borderRadius: '8px',
        bgcolor: theme =>
          theme.palette.mode === 'dark'
            ? theme.palette.background.default
            : theme.palette.grey[50],
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box
        sx={{
          p: '12px',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {error && (
          <ErrorOutlineIcon
            sx={{
              color: 'error.main',
              fontSize: '18px',
              position: 'absolute',
              top: 8,
              right: 8
            }}
          />
        )}

        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 500,
            fontSize: '15px',
            color: 'text.primary',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            mb: '4px',
            pr: '32px'
          }}
        >
          {header}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', fontSize: '12px', mb: '4px' }}
        >
          {address?.fullAdd}
        </Typography>

        {communityPhone && (
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', fontSize: '12px', mb: '10px' }}
          >
            {communityPhone}
          </Typography>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 'auto'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {tag ? (
              <>
                <Chip
                  label="In Queue"
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: '11px', fontWeight: 600, height: '24px' }}
                />
                <Tooltip
                  title={`${preLiveLeadsIngested} pre-live lead${
                    preLiveLeadsIngested !== 1 ? 's' : ''
                  } ingested`}
                  arrow
                >
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      bgcolor:
                        preLiveLeadsIngested >= 5
                          ? 'success.main'
                          : preLiveLeadsIngested > 0
                            ? 'warning.main'
                            : 'error.main'
                    }}
                  />
                </Tooltip>
                {knockWebhookEnabled !== null &&
                  knockWebhookEnabled !== undefined && (
                    <Tooltip
                      title={
                        knockWebhookEnabled
                          ? 'Knock webhook receiving leads'
                          : 'Knock webhook not receiving leads'
                      }
                      arrow
                    >
                      <WebhookIcon
                        sx={{
                          fontSize: 16,
                          color: knockWebhookEnabled
                            ? 'success.main'
                            : 'error.main'
                        }}
                      />
                    </Tooltip>
                  )}
              </>
            ) : (
              <Chip
                label="Live"
                size="small"
                sx={{
                  fontSize: '11px',
                  fontWeight: 600,
                  height: '24px',
                  bgcolor: 'rgba(76, 175, 80, 0.15)',
                  color: 'success.main'
                }}
              />
            )}
            {isCLOProperty && (
              <Tooltip title="CLO Property">
                <Chip
                  icon={<HubIcon sx={{ fontSize: '14px' }} />}
                  label="CLO"
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ fontSize: '11px', fontWeight: 600, height: '24px' }}
                />
              </Tooltip>
            )}
          </Box>
        </Box>
      </Box>

      <Checkbox
        size="small"
        sx={{
          position: 'absolute',
          top: 2,
          right: 2
        }}
        color="primary"
        checked={checked}
        onClick={handleChange}
      />
    </Card>
  );
};

export default Grid;
